import React from 'react';
import type { UserImage } from '../../shop-builder/types';

interface ShopBannerProps {
  bannerImage: UserImage | null;
}

export default function ShopBanner(props: ShopBannerProps) {
  return (
    <div className='shop-header__top'>
      <div className='shop-header__top-content'>
        {props.bannerImage && (
          <picture>
            <source
              srcSet={props.bannerImage.srcsets.avif}
              type='image/avif'
            />
            <source
              srcSet={props.bannerImage.srcsets.webp}
              type='image/webp'
            />
            <source
              srcSet={props.bannerImage.srcsets.jpeg}
              type='image/jpeg'
            />
            <img
              className='shop-header__image'
              src={props.bannerImage.webp['1080']}
              alt={props.bannerImage.alt_text || 'Banner'}
            />
          </picture>
        )}
      </div>
    </div>
  );
}
